const MAX_FREE_USAGE = 3;
const STORAGE_KEY = 'nexus_doc_usage';
export const checkUsageLimit = () => {
  const today = new Date().toDateString();
  let data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  if (data.date !== today) {
    data = { date: today, count: 0 };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }
  return { count: data.count, locked: data.count >= MAX_FREE_USAGE, max: MAX_FREE_USAGE };
};
export const incrementUsage = () => {
  const today = new Date().toDateString();
  let data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  data.count = (data.count || 0) + 1;
  data.date = today;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  return checkUsageLimit();
};
